import { render, staticRenderFns } from "./CompanyDisplay.vue?vue&type=template&id=401df3f3&scoped=true&lang=pug&"
import script from "./CompanyDisplay.vue?vue&type=script&lang=js&"
export * from "./CompanyDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDisplay.vue?vue&type=style&index=0&id=401df3f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401df3f3",
  null
  
)

export default component.exports